import * as React from "react";
import * as cn from "classnames";

import "./ChartPlaceholder.css";

export interface ChartPlaceholderProps {
    className?: string;
    size: "full" | "two-thirds" | "half" | "third" | "quarter";
    children?: React.ReactChild | React.ReactChild[];
}

export function ChartPlaceholder(props: ChartPlaceholderProps) {
    return (
        <div className={cn("chart-placeholder", props.size, props.className)}>
            <div className="chart-placeholder__inner">{props.children}</div>
        </div>
    );
}
